<template>
  <div class="box is-relative">
    <div class="columns is-hidden-mobile">
      <div class="column is-2">Feld</div>
      <div class="column is-10">Suche</div>
    </div>
    <SearchFilter v-for="filter in group.filters" v-bind:key="filter.id" v-bind:filter="filter"></SearchFilter>
    <button v-on:click="newFilter" class="button">
      <i class="im im-plus" style="font-size: 14px;"></i>
    </button>
    <div class="control is-pulled-right" style="line-height: 42px;">
      <label class="radio">
        <input type="radio" value="true" v-model="conjunctive"/>
        AND
      </label>
      <label class="radio">
        <input type="radio" value="false" v-model="conjunctive" />
        OR
      </label>
    </div>
    <div class="searchgroup-delete" v-on:click="deleteMe">
      <i class="im im-x-mark"></i>
    </div>
  </div>
</template>

<script>
import SearchFilter from "./SearchFilter.vue";
export default {
  props: ["group"],
  components: {
    SearchFilter
  },
  computed: {
    conjunctive: {
      get() {
        return this.group.conjunctive;
      },
      set(value) {
        this.$store.commit("search/groupConjunctive", {
          groupId: this.group.id, 
          conjunctive: value=="true"
        })
      }
    }
  },
  methods: {
    newFilter() {
      this.$store.commit("search/newFilter", this.group.id);
    },
    deleteMe() {
      this.$store.commit("search/deleteGroup", this.group);
    }
  }
};
</script>
